export const Global = {
  LOCAL_STORAGE_USER_FIELD: 'LIVET-APP-USER',
  LOCAL_STORAGE_SPECIALTIES: 'LIVET-APP-SESSION-SPECIALTIES',
  COLOR_STANDARD_BLUE: '#256FB5',
  COLOR_SECONDARY_BLUE: '#26B1FF'
};
